import { httpDelete, httpGet, httpPost, httpPut } from '../../../global/http-utils';

import { createLocaleSpecifierFromParts } from './utils';
import { returnResponseIfOkOrSetGlobalErrorMessage } from '../../../global/api-utils';
import { setGlobalErrorMessage } from '../../../global/app-global-values';

export const getTenantWorkflows = tenantId => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/${tenantId}/workflows`),
    `Failed to get workflows for ${tenantId}`
  );
};

export const getTenantWorkflowById = (tenantId, id) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/${tenantId}/workflows/${id}`),
    `Failed to get workflow ${id} for ${tenantId}`
  );
};

export const getWorkflowLatestRevision = (tenantId, id) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/${tenantId}/workflows/${id}/latest`),
    `Failed to get latest workflow ${id} for ${tenantId}`
  );
};

export const getWorkflowHistory = (tenantId, id) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/${tenantId}/workflows/${id}/history`),
    `Failed to get history of ${id} for ${tenantId}`
  );
};

export const addTenantWorkflow = (tenantId, workflowInfo) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPost(`tsi-multit/${tenantId}/workflows`, workflowInfo),
    `Failed to save a new workflow for ${tenantId}`
  );
};

export const addTenantSubworkflow = (tenantId, workflowId, subWorkflow) => {
  const localeSpecifier = createLocaleSpecifierFromParts(subWorkflow.sourceLocale, subWorkflow.targetLocale);
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPost(`tsi-multit/${tenantId}/workflows/${workflowId}/${localeSpecifier}`, {
        steps: subWorkflow.steps,
        tenantResources: subWorkflow.tenantResources,
      }),
    `Failed to save a new subworkflow for ${tenantId} on ${workflowId}`
  );
};

export const updateTenantSubworkflow = (tenantId, workflowId, subWorkflow, toLive) => {
  const localeSpecifier = createLocaleSpecifierFromParts(subWorkflow.sourceLocale, subWorkflow.targetLocale);
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/${tenantId}/workflows/${workflowId}/${localeSpecifier}`, {
        steps: subWorkflow.steps,
        tenantResources: subWorkflow.tenantResources,
        toLive: toLive,
        isTested: subWorkflow.isTested,
      }),
    `Failed to update subworkflow for ${tenantId} on ${workflowId}`,
    'Workflow saved successfully'
  );
};

export const deleteTenantSubworkflow = (tenantId, workflowId, localeSpecifier) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/${tenantId}/workflows/${workflowId}/${localeSpecifier}`),
    `Failed to delete subworkflow ${localeSpecifier} of ${workflowId} for ${tenantId}`,
    'Subworkflow successfully deleted'
  );
};

export const deleteTenantWorkflow = (tenantId, workflowId) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/${tenantId}/workflows/${workflowId}`),
    `Failed to delete workflow ${workflowId} for ${tenantId}`,
    'Workflow successfully deleted'
  );
};

export const getTenantWorkflowAttributeOptions = attributeName => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/workflow/tenantAttributeOptions`, undefined, { attributeName: attributeName }),
    `Could not get options for attribute ${attributeName}.`
  );
};

export const updateTenantWorkflowAttributes = (tenantId, workflowId, newAttributes, toLive) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () =>
      httpPut(`tsi-multit/${tenantId}/workflows/${workflowId}/selectorAttributes`, {
        selectionAttributes: newAttributes,
        toLive: toLive,
      }),
    `Failed to update workflow selection attributes`,
    `Successfully updated workflow selection attributes.`
  );
};

export const initiateAbMetricsLookup = (
  tenantId,
  workflowId,
  experimentId,
  metricsRoleArn,
  successCallback,
  failureCallback
) => {
  httpPost(`tsi-multit/${tenantId}/workflows/experiments/${experimentId}`, {
    metricsRoleArn: metricsRoleArn,
  })
    .then(response => {
      if (response.status === 202) {
        //verified metrics requester, start pulling metrics
        successCallback(true);
      } else if (response.status === 201) {
        //unverified metrics requester, created email verification
        successCallback(false);
      } else {
        throw Error();
      }
    })
    .catch(() => {
      setGlobalErrorMessage(`Failed to initiate AB test metrics lookup for experiment ${experimentId}`);
      failureCallback();
    });
};
